(() => {
  window.LSFitFinderCategories = window.LSFitFinderCategories || {};

  const months = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
  const monthNumber = (value) => months.indexOf(String(value || '').toLowerCase()) + 1;
  const monthName = (number) => months[number - 1] ? months[number - 1][0].toUpperCase() + months[number - 1].slice(1) : '';

  const fallbackBenefitIcons = [
    '<svg viewBox="0 0 32 32" focusable="false"><path d="M16 3 26 7v8c0 7-4.6 11.6-10 14-5.4-2.4-10-7-10-14V7l10-4Z"></path><path d="m11 16 3 3 7-8"></path></svg>',
    '<svg viewBox="0 0 32 32" focusable="false"><path d="M16 27V14"></path><path d="M16 17c-6 0-9-3-9-8 6 0 9 3 9 8Z"></path><path d="M16 13c6 0 9-3 9-8-6 0-9 3-9 8Z"></path><path d="M9 27h14"></path></svg>',
    '<svg viewBox="0 0 32 32" focusable="false"><path d="M6 26c2-8 4-13 7-19 1 7 1 12 0 19"></path><path d="M14 26c2-10 5-16 8-21 0 8-1 14-3 21"></path><path d="M4 26h24"></path></svg>'
  ];

  window.LSFitFinderCategories.fertilizer = {
    restartStep: 'grass',

    initialize(ctx) {
      const dataNode = ctx.root.querySelector('[data-fit-fertilizer-data]');
      ctx.data = dataNode ? JSON.parse(dataNode.textContent) : { programs: [] };
      ctx.selectedProgram = null;
      ctx.isStarter = ctx.root.dataset.starterFertilizer === 'true';
      ctx.isSpecialty = ctx.root.dataset.specialtyFertilizer === 'true';
      ctx.currentProductId = String(ctx.root.dataset.currentProductId || '');
      ctx.copy = {
        matchTitle: ctx.root.dataset.fertilizerMatchTitle || 'Yes — this is the right fertilizer for your lawn.',
        alternativeTitle: ctx.root.dataset.fertilizerAlternativeTitle || 'This product is a good alternative for your lawn right now.',
        alternativeCopy: ctx.root.dataset.fertilizerAlternativeCopy || 'This product is an approved alternative for this lawn program.',
        starterTitle: ctx.root.dataset.starterMatchTitle || 'Yes — this is the right fertilizer',
        starterCopy: ctx.root.dataset.starterMatchCopy || 'This is the right fertilizer if you are starting a new lawn, overseeding, or need additional NPK nutrients for your lawn.',
        differentTitle: ctx.root.dataset.fertilizerDifferentTitle || 'We recommend a different fertilizer for your lawn this month',
        differentCopy: ctx.root.dataset.fertilizerDifferentCopy || '',
        emptyTitle: ctx.root.dataset.fertilizerEmptyTitle || 'We need a little more information',
        emptyCopy: ctx.root.dataset.fertilizerEmptyCopy || 'We could not find a fertilizer recommendation for these selections.'
      };

      ctx.specialtyTemplate = ctx.root.querySelector('[data-fit-specialty-note-template]');
      ctx.specialtyNote = ctx.root.querySelector('[data-fit-specialty-note]');
      ctx.futureNote = ctx.root.querySelector('[data-fit-future-note]');
      ctx.summaryMonth = ctx.root.querySelector('[data-fit-summary-month]');
      ctx.planToggle = ctx.root.querySelector('[data-fit-fertilizer-plan-toggle]');
      ctx.planPanel = ctx.root.querySelector('[data-fit-fertilizer-plan-panel]');
      ctx.planContent = ctx.root.querySelector('[data-fit-fertilizer-plan-content]');
      ctx.planLabel = ctx.root.querySelector('[data-fit-fertilizer-plan-label]');
      ctx.alternativesToggle = ctx.root.querySelector('[data-fit-fertilizer-alternatives-toggle]');
      ctx.alternativesPanel = ctx.root.querySelector('[data-fit-fertilizer-alternatives-panel]');
      ctx.alternativesContent = ctx.root.querySelector('[data-fit-fertilizer-alternatives-content]');
      ctx.resultContent = ctx.root.querySelector('.ls-v2-fit-finder__result-content');
      ctx.card = ctx.root.querySelector('[data-fit-fertilizer-recommendation]');
      ctx.media = ctx.root.querySelector('[data-fit-fertilizer-media]');
      ctx.kicker = ctx.root.querySelector('[data-fit-fertilizer-kicker]');
      ctx.title = ctx.root.querySelector('[data-fit-fertilizer-title]');
      ctx.description = ctx.root.querySelector('[data-fit-fertilizer-description]');
      ctx.benefits = ctx.root.querySelector('[data-fit-fertilizer-benefits]');
      ctx.link = ctx.root.querySelector('[data-fit-fertilizer-link]');

      const closeUtilityPanels = (except = null) => {
        [
          [ctx.planToggle, ctx.planPanel],
          [ctx.alternativesToggle, ctx.alternativesPanel]
        ].forEach(([toggle, panel]) => {
          if (!toggle || !panel || panel === except) return;
          panel.hidden = true;
          toggle.setAttribute('aria-expanded', 'false');
          toggle.classList.remove('is-open');
        });
      };

      if (ctx.planToggle && ctx.planPanel) {
        ctx.planToggle.addEventListener('click', () => {
          const willOpen = ctx.planPanel.hidden;
          closeUtilityPanels(willOpen ? ctx.planPanel : null);
          ctx.planPanel.hidden = !willOpen;
          ctx.planToggle.setAttribute('aria-expanded', String(willOpen));
          ctx.planToggle.classList.toggle('is-open', willOpen);
          if (willOpen) {
            ctx.planPanel.querySelector('.ls-v2-fit-finder__plan-row.is-current')?.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
          }
        });
      }

      if (ctx.alternativesToggle && ctx.alternativesPanel) {
        ctx.alternativesToggle.addEventListener('click', () => {
          const willOpen = ctx.alternativesPanel.hidden;
          closeUtilityPanels(willOpen ? ctx.alternativesPanel : null);
          ctx.alternativesPanel.hidden = !willOpen;
          ctx.alternativesToggle.setAttribute('aria-expanded', String(willOpen));
          ctx.alternativesToggle.classList.toggle('is-open', willOpen);
        });
      }
    },

    clear(ctx) {
      [ctx.planToggle, ctx.planPanel, ctx.alternativesToggle, ctx.alternativesPanel, ctx.card, ctx.specialtyNote, ctx.futureNote].forEach((element) => {
        if (element) element.hidden = true;
      });
      if (ctx.resultContent) ctx.resultContent.hidden = false;
      [ctx.planToggle, ctx.alternativesToggle].forEach((toggle) => {
        if (!toggle) return;
        toggle.setAttribute('aria-expanded', 'false');
        toggle.classList.remove('is-open');
      });
      if (ctx.planContent) ctx.planContent.innerHTML = '';
      if (ctx.alternativesContent) ctx.alternativesContent.innerHTML = '';
      if (ctx.specialtyNote) ctx.specialtyNote.textContent = '';
      if (ctx.futureNote) ctx.futureNote.textContent = '';
      if (ctx.benefits) {
        ctx.benefits.innerHTML = '';
        ctx.benefits.hidden = true;
      }
    },

    resolveProgram(ctx) {
      const grass = ctx.normalize(ctx.answers.grass);
      const region = ctx.normalize(ctx.answers.region);
      const cool = new Set(['kentucky bluegrass', 'perennial ryegrass', 'fine fescue', 'tall fescue', 'northern cool-season']);
      const warm = new Set(['bermuda', 'zoysia', 'st augustine', 'centipede', 'warm season lawn']);
      const matchesGrass = (name) => {
        const value = ctx.normalize(name);
        return value === grass || (cool.has(grass) && value.includes('cool season')) || (warm.has(grass) && value.includes('warm season'));
      };
      const candidates = (ctx.data.programs || []).filter((program) => (program.grassTypes || []).some(matchesGrass));
      const matchesRegion = (program) => {
        const value = ctx.normalize(program.region);
        return region === 'florida' || region === 'southern' ? value.includes('florida') || value === 'southern' : value === region;
      };
      return candidates.find(matchesRegion) || candidates[0] || null;
    },

    currentStep(program) {
      const steps = (program?.steps || []).filter((step) => step.product);
      if (!steps.length) return null;
      const current = new Date().getMonth() + 1;
      return steps.find((step) => (step.activeMonths || []).some((month) => monthNumber(month) === current))
        || steps.map((step) => ({ step, month: monthNumber(step.month) })).filter((item) => item.month >= current).sort((a, b) => a.month - b.month)[0]?.step
        || steps[0];
    },

    futureStep(ctx) {
      const current = new Date().getMonth() + 1;
      return (ctx.selectedProgram?.steps || [])
        .filter((step) => step.product && String(step.product.id || '') === ctx.currentProductId)
        .map((step) => ({ step, month: monthNumber(step.month) }))
        .filter((item) => item.month > current)
        .sort((a, b) => a.month - b.month)[0]?.step || null;
    },

    monthLabel(step) {
      const current = new Date().getMonth() + 1;
      return (step?.activeMonths || []).some((month) => monthNumber(month) === current) ? monthName(current) : step?.month || 'Seasonal';
    },

    renderBenefits(ctx, benefits) {
      if (!ctx.benefits) return;
      const items = (benefits || []).filter((benefit) => benefit?.title).slice(0, 3);
      if (!items.length) {
        ctx.benefits.innerHTML = '';
        ctx.benefits.hidden = true;
        return;
      }

      ctx.benefits.innerHTML = items.map((benefit, index) => {
        const slot = index + 1;
        const productIcon = benefit.icon
          ? '<span class="ls-v2-fit-finder__benefit-icon has-product-icon" style="--ls-fit-benefit-product-icon:url(\'' + ctx.escapeHtml(benefit.icon) + '\')" aria-hidden="true"></span>'
          : '<span class="ls-v2-fit-finder__benefit-icon ls-v2-fit-finder__benefit-icon--' + slot + '" aria-hidden="true">' + fallbackBenefitIcons[index] + '</span>';
        const words = String(benefit.title || '').trim().split(/\s+/);
        const lead = words.shift() || '';
        const rest = words.join(' ');
        return '<div class="ls-v2-fit-finder__benefit-item">' + productIcon + '<span><strong>' + ctx.escapeHtml(lead) + '</strong>' + (rest ? '<small>' + ctx.escapeHtml(rest) + '</small>' : '') + '</span></div>';
      }).join('');
      ctx.benefits.hidden = false;
    },

    renderPlan(ctx, currentStep) {
      if (!ctx.planToggle || !ctx.planContent || !ctx.selectedProgram) return;
      const steps = (ctx.selectedProgram.steps || []).filter((step) => step.product);
      const current = currentStep || steps[0];
      const escape = ctx.escapeHtml;
      const timeline = steps.map((step) => (
        '<div class="ls-v2-fit-finder__plan-row' + (step === current ? ' is-current' : '') + '">' +
          '<span class="ls-v2-fit-finder__plan-month">' + escape(this.monthLabel(step)) + '</span>' +
          '<span class="ls-v2-fit-finder__plan-goal">' + escape(step.goal || 'Seasonal care') + '</span>' +
          '<a class="ls-v2-fit-finder__plan-product" href="' + escape(step.product.url || '#') + '">' + escape(step.product.title || '') + '</a>' +
        '</div>'
      )).join('');
      ctx.planContent.innerHTML = '<div class="ls-v2-fit-finder__plan-timeline">' + timeline + '</div>';
      if (ctx.planLabel) ctx.planLabel.textContent = ctx.root.dataset.planLinkLabel || 'View Full Lawn Program';
      ctx.planToggle.hidden = false;
    },

    showResult(ctx, step) {
      if (!step?.product) {
        return ctx.showResult({ match: false, icon: '!', title: ctx.copy.emptyTitle, copy: ctx.copy.emptyCopy });
      }

      const same = ctx.isStarter || String(step.product.id || '') === ctx.currentProductId;
      const alternative = !same && (step.alternativeProducts || []).some((product) => String(product.id || '') === ctx.currentProductId);
      const accepted = same || alternative;
      const month = this.monthLabel(step);
      const resultCopy = same
        ? (ctx.isStarter ? ctx.copy.starterCopy : 'Recommended for your ' + month + ' application.')
        : alternative
          ? ctx.copy.alternativeCopy
          : ctx.copy.differentCopy;
      const specialtyMarkup = ctx.isSpecialty && ctx.specialtyTemplate?.innerHTML.trim() ? ctx.specialtyTemplate.innerHTML.trim() : '';

      ctx.showResult({
        match: accepted,
        icon: accepted ? '✓' : '→',
        title: same ? (ctx.isStarter ? ctx.copy.starterTitle : ctx.copy.matchTitle) : alternative ? ctx.copy.alternativeTitle : ctx.copy.differentTitle,
        copy: resultCopy
      });

      if (ctx.summaryMonth) ctx.summaryMonth.textContent = 'Recommended for ' + month;

      if (specialtyMarkup && ctx.el.resultCopy) {
        ctx.el.resultCopy.innerHTML = '<div class="ls-v2-fit-finder__specialty-reason">' + specialtyMarkup + '</div><div class="ls-v2-fit-finder__specialty-match">' + ctx.escapeHtml(resultCopy) + '</div>';
      }

      const future = !accepted ? this.futureStep(ctx) : null;
      if (future?.product && ctx.futureNote) {
        const futureMonth = future.month || 'upcoming month';
        ctx.futureNote.innerHTML = '<strong>Buying ahead for ' + ctx.escapeHtml(futureMonth) + '?</strong> ' + ctx.escapeHtml(future.product.title) + ' is the recommended fertilizer for your ' + ctx.escapeHtml(futureMonth) + ' application. It is a good product to purchase now and have ready.';
        ctx.futureNote.hidden = false;
      }

      if (ctx.alternativesToggle && ctx.alternativesContent) {
        const products = [];
        const addProduct = (product) => {
          if (!product || String(product.id || '') === ctx.currentProductId) return;
          if (!products.some((item) => String(item.id || '') === String(product.id || ''))) products.push(product);
        };
        if (alternative) addProduct(step.product);
        (step.alternativeProducts || []).forEach(addProduct);
        if (products.length) {
          ctx.alternativesContent.innerHTML = '<div class="ls-v2-fit-finder__plan-timeline">' + products.map((product) => '<a class="ls-v2-fit-finder__plan-product" href="' + ctx.escapeHtml(product.url || '#') + '">' + ctx.escapeHtml(product.title || '') + '</a>').join('') + '</div>';
          ctx.alternativesToggle.hidden = false;
        }
      }

      // A positive V3 fit is already confirmation for the product being viewed.
      // Only display a separate product card when the current product isn't a fit.
      // Keep the existing V2 presentation and all full-program controls intact.
      const showRecommendation = !ctx.root.classList.contains('ls-v2-fit-finder--v3') || !accepted;
      if (ctx.resultContent) ctx.resultContent.hidden = !showRecommendation;
      if (ctx.card) {
        ctx.card.hidden = !showRecommendation;
        if (showRecommendation) {
          ctx.card.classList.toggle('is-current', same);
          ctx.kicker.textContent = same ? 'YOUR ' + month.toUpperCase() + ' APPLICATION' : 'OUR RECOMMENDATION';
          ctx.title.textContent = step.product.title || '';

          const description = step.product.shortDescription || step.description || '';
          ctx.description.textContent = description;
          ctx.description.hidden = !description;
          this.renderBenefits(ctx, step.product.benefits);

          ctx.link.href = step.product.url || '#';
          ctx.link.hidden = false;

          if (step.product.image) {
            ctx.media.href = step.product.url || '#';
            ctx.media.innerHTML = '<img src="' + ctx.escapeHtml(step.product.image) + '" alt="" loading="lazy" width="420" height="420">';
            ctx.media.hidden = false;
          } else {
            ctx.media.hidden = true;
          }
        }
      }

      this.renderPlan(ctx, step);
    },

    onOption(ctx, option) {
      if (option.dataset.fitType !== 'grass') return;
      if (ctx.isSpecialty && option.dataset.fitSupported !== 'true') {
        return ctx.showMismatch('grass', option.dataset.fitLabel || 'your selection');
      }
      if (ctx.answers.state) {
        ctx.selectedProgram = this.resolveProgram(ctx);
        const step = this.currentStep(ctx.selectedProgram);
        return step ? this.showResult(ctx, step) : ctx.showMismatch('grass', option.dataset.fitLabel || 'your selection');
      }
      const savedStateCode = String(ctx.el.stateSelect?.value || '').toUpperCase();
      if (savedStateCode && ctx.applyState) return ctx.applyState(savedStateCode, true);
      if (!ctx.state.lookupFinished) {
        ctx.el.statePrompt.textContent = 'Finding your state…';
        ctx.el.stateSelect.hidden = true;
        ctx.el.stateContinue.hidden = true;
        return ctx.showStep('state');
      }
      return ctx.requestState();
    },

    onState(ctx) {
      ctx.selectedProgram = this.resolveProgram(ctx);
      if (ctx.answers.grass) this.showResult(ctx, this.currentStep(ctx.selectedProgram));
    },

    onLookupMiss(ctx) {
      ctx.el.statePrompt.textContent = 'Where is your lawn located?';
      ctx.el.stateSelect.hidden = false;
      ctx.el.stateContinue.hidden = false;
      ctx.el.stateContinue.disabled = true;
    }
  };
})();
